module.exports = __webpack_public_path__ + "media/images/places/horta-saberes-ambientais-604e15f345236ab21a7e37e98811f3d0.jpg";